/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_6_Paragraphs_2Inputs */

const en_gc_search_guides_gridcraft_online_sections_6_paragraphs_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_6_Paragraphs_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If the file opens but interaction feels slow, keep the test controlled. Compare a small sample with the same workbook, close unrelated heavy tabs, and note the action that stalls: launch, import, recalculation or scrolling. Those are different operations. Record the browser, device and GridCraft version when investigating so that a future test compares the same conditions rather than a different setup.`)
};

const zh_gc_search_guides_gridcraft_online_sections_6_paragraphs_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_6_Paragraphs_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果文件能打开但操作缓慢，应控制测试条件。用小示例作对照，关闭无关的高负载标签页，并记录卡顿发生在启动、导入、重新计算还是滚动阶段。这些属于不同操作。排查时同时记录浏览器、设备与 GridCraft 版本，保证后续比较基于相同条件。`)
};

/**
* | output |
* | --- |
* | "If the file opens but interaction feels slow, keep the test controlled. Compare a small sample with the same workbook, close unrelated heavy tabs, and note t..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_6_Paragraphs_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_6_paragraphs_2 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_6_Paragraphs_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_6_Paragraphs_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_6_paragraphs_2(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_6_paragraphs_2(inputs)
});
export { gc_search_guides_gridcraft_online_sections_6_paragraphs_2 as "gc.search_guides.gridcraft_online.sections.6.paragraphs.2" }